<template lang="pug">
  v-row
    template(v-if="value")
      v-col(cols=12)
        v-text-field(
          :value="value['search[name]']"
          label="Логин"
          rounded filled
          hide-details
          @change="searchKeys['search[name]'] = $event"
        )
      template(v-if="courseType === $conf.COURSE_TYPES.general")
        v-col(cols=6)
          v-select(
            :value="value['search[pfdo_program]']"
            :items="pfdoPrograms"
            item-text="program_name"
            item-value="id"
            label="Программа"
            hide-details
            rounded filled clearable
            @input="searchKeys['search[pfdo_program]'] = $event"
          )
        v-col(cols=6)
          v-select(
            :value="value['search[pfdo_group]']"
            :items="pfdoGroups"
            item-text="group_name"
            item-value="id"
            label="Группа"
            hide-details
            rounded filled clearable
            @click:clear="searchKeys['search[pfdo_group]'] = null"
            @input="searchKeys['search[pfdo_group]'] = $event"
          )
      template(v-else)
        v-col(cols=12)
          v-autocomplete(
            :value="value['search[group_id]']"
            :items="groups"
            item-text="short_name"
            item-value="id"
            label="Группа"
            hide-details
            rounded
            filled
            clearable
            @click:clear="searchKeys['search[group_id]'] = null"
            @input="searchKeys['search[group_id]'] = $event"
          )
      v-col(cols=12)
        v-expand-transition
          v-btn(
            v-if="hasFilters"
            block
            depressed
            rounded
            large
            @click="reset"
          )
            span Сбросить
            v-icon(right) mdi-close
</template>

<script>
export default {
  name: 'EnrollmentElementFilters',
  props: {
    value: { type: Object, default: () => ({}) },
    groups: { type: Array, required: true },
    courseType: { type: Number, required: true },
    courseId: { type: Number, required: true },
  },
  data() {
    return {
      searchKeys: {
        'search[pfdo_program]': null,
        'search[pfdo_group]': null,
        'search[group]': null,
        'search[name]': null,
        'search[full_name]': null,
      },

      pfdoPrograms: [],
      pfdoGroups: [],
    };
  },
  computed: {
    hasFilters() {
      return Object.values(this.searchKeys).find((v) => v);
    },
  },
  watch: {
    searchKeys: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true,
    },
  },
  created() {
    if (!this.value) this.$emit('input', this.searchKeys);
    else this.searchKeys = { ...this.value };
    this.getPfdoResources();
  },
  methods: {
    reset() {
      Object.entries(this.searchKeys).forEach(([key]) => {
        this.searchKeys[key] = null;
      });
    },
    getPfdoResources() {
      this.$rHandler(
        this.$api.courses.getCourseResources(this.courseId),
        (r) => {
          this.pfdoPrograms = r.data.data.programs;
          this.pfdoGroups = r.data.data.groups;
        },
      );
    },
  },
};
</script>
